export function getBrowserId(): string {
  const key = 'browser_id';
  let id = localStorage.getItem(key);

  if (!id) {
    id = crypto.randomUUID(); // ou use uuid v4 lib
    localStorage.setItem(key, id);
  }

  return id;
}
